export const shouldRenderPlanLoadingCue = ({ isLoading, showLoadingCue }) => (
  Boolean(isLoading && showLoadingCue)
);
